import React from 'react';

/* eslint import/no-webpack-loader-syntax: off */
import EducationIcon from '-!svg-react-loader!../../assets/icons/commons/education.svg';
import MonitorIcon  from '-!svg-react-loader!../../assets/icons/commons/monitor.svg';
import CloseIcon  from '-!svg-react-loader!../../assets/icons/commons/close.svg';
import AttachmentIcon  from '-!svg-react-loader!../../assets/icons/commons/attachment.svg';
import LocationIcon  from '-!svg-react-loader!../../assets/icons/commons/location.svg';
import MailIcon  from '-!svg-react-loader!../../assets/icons/commons/mail.svg';
import PhoneIcon from '-!svg-react-loader!../../assets/icons/commons/phone.svg';
import UsersIcon from '-!svg-react-loader!../../assets/icons/commons/users.svg';
import AssessmentIcon from '-!svg-react-loader!../../assets/icons/commons/assessment.svg';
import AnalyticsIcon from '-!svg-react-loader!../../assets/icons/commons/analytics.svg';
import AppsIcon from '-!svg-react-loader!../../assets/icons/commons/apps.svg';
import CoursesIcon from '-!svg-react-loader!../../assets/icons/commons/courses.svg';
import EpIcon from '-!svg-react-loader!../../assets/icons/commons/ep.svg';
import PortalIcon from '-!svg-react-loader!../../assets/icons/commons/portal.svg';
// import RobocodeIcon from '-!svg-react-loader!../../assets/icons/commons/robocode.svg';

export const iconsMap: any = {
  AssessmentIcon,
  UsersIcon,
  AnalyticsIcon,
  AppsIcon,
  EpIcon,
  PortalIcon,
  CoursesIcon,
  EducationIcon,
  MonitorIcon,
  CloseIcon,
  AttachmentIcon,
  PhoneIcon,
  LocationIcon,
  MailIcon,
};

export const getIcon = (icon: any) => { const Icon = iconsMap[icon]; return <Icon />; };
